import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const BarraLateralClinica = () => {
    const location = useLocation();
    
    // Auth check
    const user = JSON.parse(localStorage.getItem('user'));
    const roleName = user?.role_details?.name;
    const isAdmin = roleName === 'SUPER_ADMIN' || roleName === 'ADMIN_FAST_FOOD' || roleName === 'ADMIN_CLINIC' || user?.is_superuser;

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <aside className="sidebar">
            <div className="sidebar-header" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="bi bi-eye"></i> Vision Click
            </div>
            <ul className="sidebar-nav">
                <li className={isActive('/clinica')}>
                    <Link to="/clinica">Panel Principal</Link>
                </li>
                <li className={isActive('/clinica/agenda')}>
                    <Link to="/clinica/agenda">Agenda / Citas</Link>
                </li>
                <li className={isActive('/clinica/historia-visual')}>
                    <Link to="/clinica/historia-visual">Historia Visual</Link>
                </li>
                <li className={isActive('/clinica/consultas')}>
                    <Link to="/clinica/consultas">Presupuestos / Recetas</Link>
                </li>
                <li className={isActive('/clinica/registro-mensual')}>
                    <Link to="/clinica/registro-mensual">Registro Mensual</Link>
                </li>
                <li className={isActive('/clinica/pacientes')}>
                    <Link to="/clinica/pacientes">Pacientes</Link>
                </li>
                <li className={isActive('/clinica/certificado-visual')}>
                    <Link to="/clinica/certificado-visual">Certificado Visual</Link>
                </li>
                <li className={isActive('/clinica/servicios')}>
                    <Link to="/clinica/servicios">Servicios</Link>
                </li>
                <li className={isActive('/clinica/procedimientos')}>
                    <Link to="/clinica/procedimientos">Procedimientos</Link>
                </li>
                <li className={isActive('/clinica/bodega')}>
                    <Link to="/clinica/bodega">Inventario (Armazones)</Link>
                </li>
                <li className={isActive('/clinica/graficos-consentimiento')}>
                    <Link to="/clinica/graficos-consentimiento">Gráficos Consentimiento</Link>
                </li>
                <li className={isActive('/clinica/printers')}>
                    <Link to="/clinica/printers">Impresoras</Link>
                </li>

            </ul>
        </aside>
    );
};

export default BarraLateralClinica;